import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'patient-bmi-card-small',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bmi-card-small.component.html',
  styleUrl: './bmi-card-small.component.css'
})
export class BmiCardSmallComponent {
  @Input() bmiValue: number = 0;

  private router = inject(Router);

  getBMICategory(bmi: number): string {
    if (bmi <= 0) return 'No data';
    if (bmi < 18.5) return 'Your weight is Underweight';
    if (bmi < 25.0) return 'Your weight is Normal';
    if (bmi < 30.0) return 'Your weight is Overweight';
    return 'Your weight is Obese';
  }

  getPointerPosition(bmi: number): string {
    // Normalizing BMI from 10 to 40 for the scale
    const min = 10;
    const max = 40;
    const pos = ((bmi - min) / (max - min)) * 100;
    return Math.min(Math.max(pos, 0), 100) + '%';
  }

  navigateToDetails() {
    this.router.navigate(['/bmi-details']);
  }
}
